import { useAppDispatch, useAppSelector, useDeviceType } from "app/hooks";
import { useToastService } from "app/hooks/useToastService";
import Lottie from "lottie-react";
import HeartJson from 'Assets/heart-icon.json'
import {
  addMember,
  changeID,
  clearDisabledProposerFields,
  clearPreviousPolicyMemberHavingDisease,
  removeMembers,
  updateAuthToken,
  updateDisabledProposerFields,
  updateLeadUID,
  updateMembersStoreData,
  updateNomineeData,
  updatePanNumber,
  updatePaymentModalStatus,
  updatePolicyDetails,
  updatePreviousPolicyMemberHavingDisease,
  updateProposerData,
  updateUserStatus,
} from "features/member.slice";
import {
  CapturedCustomerDetails,
  HealthListingPolicyDetails,
} from "Interfaces/general";
import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import uuid from "react-uuid";
import {
  useLazyGetHealthListingQuery,
  useLazyGetHealthPaymentStatusQuery,
} from "Services/API/quote.api";
import {
  convertDOBToYYYYMMDD,
  getDiseasesList,
  getMemberTypeDisplayText,
} from "Services/general";
// import { ToastService } from "Services/toast.service";
import { useLazyLoginWithSSOTokenQuery, useLoginWithSSOTokenQuery } from "../../Services/API/auth.api";
import spouse from "../../Assets/spouse-image.png";
import you from "../../Assets/you-image.png";
import daughter from "../../Assets/daughter-image.png";
import son from "../../Assets/son-image.png";
import mother from "../../Assets/mother-image.png";
import motherInLaw from "../../Assets/motherInLaw-image.png";
import father from "../../Assets/father-image.png";
import fatherInLaw from "../../Assets/fatherInLaw-image.png";
import { Box, Center, Spinner, Text, } from "@chakra-ui/react";
import logo from "../../Assets/logo.png";
import { useLeadCRUD } from "app/useLeadCRUD";
import { config } from "config";
import { useLazyGetLeadListingQuery } from "Services/API/lms.api";

const SSOLogin = () => {
  const { token } = useParams();

  const [login, { data, error }] = useLazyLoginWithSSOTokenQuery();

  const { isMobile} = useDeviceType()

  useEffect(() => {
    login(token!).unwrap()
  }, [])

  const [getPaymentStatus] = useLazyGetHealthPaymentStatusQuery();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const { proposer } = useAppSelector(state => state.members)
  const [
    getListing,
    { data: HealthListingData, isLoading: HealthListingDataLoading },
  ] = useLazyGetHealthListingQuery();

  const [getLeadListing] = useLazyGetLeadListingQuery()
  // console.log(data, error);
  const { showErrorToast } = useToastService();
  // const [shouldCreateLead, setShouldCreateLead] = useState(false)

  // const { leadCreate } = useLeadCRUD({
  //   leadStage: 'PRE-QUOTATION'
  // })

  // return true if member has diseases and also update the store (oldMemberHasDisease)
  const checkForDiseasesPresent = (customer: CapturedCustomerDetails) => {
    let oldDiseasesList = [
      "bloodPressure",
      "bloodDisorder",
      "cancer",
      "neuromuscularDisorder",
      "cardiovascularDisease",
      "endocrineDisorder",
      "immunityDisorder",
      "diabetesHypertensionHyperlipidaemia",
      "liverDisease",
      "brainStroke",
      "kidneyUrinaryReproductiveDisease",
      "oldDiseaseFlag",
    ];
    console.log("is it here?");
    console.log(customer.relationship.toLowerCase());
    if (customer.relationship.toLowerCase() == "self") {
      let selfHasDisease = false;
      let diseaseList: string[] = [];
      // check for diseases
      Object.entries(customer.extra_info).forEach(([key, value]) => {
        if (oldDiseasesList.includes(key)) {
          if (value == 1) {
            if (key == "oldDiseaseFlag") {
              selfHasDisease = true;
            } else {
              diseaseList.push(key);
            }
          }
        }
      });
      dispatch(
        updatePreviousPolicyMemberHavingDisease({
          self: {
            hasDisease: selfHasDisease,
            diseaseList: diseaseList,
            isIncluded: true,
          },
        })
      );
    }
    if (customer.relationship.toLowerCase() == "spouse") {
      let spouseHasDisease = false;
      let diseaseList: string[] = [];
      // check for diseases
      Object.entries(customer.extra_info).forEach(([key, value]) => {
        if (oldDiseasesList.includes(key)) {
          if (value == 1) {
            if (key == "oldDiseaseFlag") {
              spouseHasDisease = true;
            } else {
              diseaseList.push(key);
            }
          }
        }
      });
      dispatch(
        updatePreviousPolicyMemberHavingDisease({
          spouse: {
            hasDisease: spouseHasDisease,
            diseaseList: diseaseList,
            isIncluded: true,
          },
        })
      );
    }
    if (customer.relationship.toLowerCase() == "mother") {
      let motherHasDisease = false;
      let diseaseList: string[] = [];
      // check for diseases
      Object.entries(customer.extra_info).forEach(([key, value]) => {
        if (oldDiseasesList.includes(key)) {
          if (value == 1) {
            if (key == "oldDiseaseFlag") {
              motherHasDisease = true;
            } else {
              diseaseList.push(key);
            }
          }
        }
      });
      dispatch(
        updatePreviousPolicyMemberHavingDisease({
          mother: {
            hasDisease: motherHasDisease,
            diseaseList: diseaseList,
            isIncluded: true,
          },
        })
      );
    }
    if (customer.relationship.toLowerCase() == "father") {
      let fatherHasDisease = false;
      let diseaseList: string[] = [];
      // check for diseases
      Object.entries(customer.extra_info).forEach(([key, value]) => {
        if (oldDiseasesList.includes(key)) {
          if (value == 1) {
            if (key == "oldDiseaseFlag") {
              fatherHasDisease = true;
            } else {
              diseaseList.push(key);
            }
          }
        }
      });
      dispatch(
        updatePreviousPolicyMemberHavingDisease({
          father: {
            hasDisease: fatherHasDisease,
            isIncluded: true,
            diseaseList: diseaseList,
          },
        })
      );
    }
    if (customer.relationship.toLowerCase() == "mother_in_law") {
      let motherInLawHasDisease = false;
      let diseaseList: string[] = [];
      // check for diseases
      Object.entries(customer.extra_info).forEach(([key, value]) => {
        if (oldDiseasesList.includes(key)) {
          if (value == 1) {
            if (key == "oldDiseaseFlag") {
              motherInLawHasDisease = true;
            } else {
              diseaseList.push(key);
            }
          }
        }
      });
      dispatch(
        updatePreviousPolicyMemberHavingDisease({
          "mother-in-law": {
            hasDisease: motherInLawHasDisease,
            isIncluded: true,
            diseaseList: diseaseList,
          },
        })
      );
    }
    if (customer.relationship.toLowerCase() == "father_in_law") {
      let fatherInLawHasDisease = false;
      let diseaseList: string[] = [];
      // check for diseases
      Object.entries(customer.extra_info).forEach(([key, value]) => {
        if (oldDiseasesList.includes(key)) {
          if (value == 1) {
            if (key == "oldDiseaseFlag") {
              fatherInLawHasDisease = true;
            } else {
              diseaseList.push(key);
            }
          }
        }
      });
      dispatch(
        updatePreviousPolicyMemberHavingDisease({
          "father-in-law": {
            hasDisease: fatherInLawHasDisease,
            isIncluded: true,
            diseaseList: diseaseList,
          },
        })
      );
    }
    if (customer.relationship.toLowerCase() == "son") {
      dispatch(
        updatePreviousPolicyMemberHavingDisease({
          son: {
            hasDisease: false,
            isIncluded: true,
            diseaseList: [],
          },
        })
      );
    }
    if (customer.relationship.toLowerCase() == "daughter") {
      dispatch(
        updatePreviousPolicyMemberHavingDisease({
          daughter: {
            hasDisease: false,
            isIncluded: true,
            diseaseList: [],
          },
        })
      );
    }

    return false;
  };

  // return true or false if any of the member have pre existing diseases
  const checkforOldmembersHavingChronicDisease = (
    customers: CapturedCustomerDetails[]
  ) => {
    if (customers.length > 0) {
      customers.map((custInfo) => {
        checkForDiseasesPresent(custInfo);
      });
    }
  };

  const deleteAndUpdateNewMemberData = (
    polices: HealthListingPolicyDetails[],
    isOldUser: boolean
  ) => {
    dispatch(removeMembers());

    polices.forEach((policy) => {
      if (policy.policy_name === "policy1") {
        if (policy.extrainfo) {
          dispatch(updateNomineeData({
            nomineeDob: policy.extrainfo?.nominee_dob,
            nomineeName: policy.extrainfo?.nominee_name,
            nomineeRelationship: policy.extrainfo?.nominee_relationship
          }))
        }
        if (isOldUser) checkforOldmembersHavingChronicDisease(policy.customers);
        dispatch(
          updatePolicyDetails({
            type: "policy1Data",
            data: {
              deductible: policy.deductibles.toString(),
              sumInsured: policy.customers[0].extra_info.sumInsured.toString(),
              premium: (policy.master_premium / 1.18).toString(),
              premiumWithGST: policy.master_premium.toString(),
              id: "1",
            },
          })
        );
        if (policy.customers) {
          policy.customers.forEach((customer) => {
            if (customer.relationship === "SELF") {
              if (customer?.extra_info?.pan) {
                dispatch(updatePanNumber(customer.extra_info?.pan))
              }
              dispatch(
                addMember({
                  code: uuid(),
                  image: you,
                  policyType: "1",
                  type: "self",
                  memberTypeDisplayText: getMemberTypeDisplayText("self"),
                  firstName: customer.first_name,
                  lastName: customer.last_name == "." ? "" : customer.last_name,
                  middleName:
                    customer.middle_name == "." ? "" : customer.middle_name,
                  dob: customer.dob,
                  haspreExistingDiseases: getDiseasesList(customer.extra_info)
                    .length
                    ? true
                    : false,
                  haslifestyleQuestions:
                    customer.extra_info.alcohol == "1" ||
                    customer.extra_info.tobacco == "1",
                  isHospitalized: customer.extra_info.hospitalized,
                  otherPEDs: customer.extra_info.otherDiseases ?? "",
                  extraOldDisease: customer.extra_info.otherDiseases ?? "",
                  preExistingDiseasesList: getDiseasesList(
                    customer.extra_info
                  )?.map((item) => item.label),
                  perMemberPremium: "",
                  perMemberPremiumWithGST: "",
                })
              );
            }
            if (customer.relationship === "SPOUSE") {
              dispatch(
                addMember({
                  code: uuid(),
                  image: spouse,
                  policyType: "1",
                  type: "spouse",
                  memberTypeDisplayText: getMemberTypeDisplayText("spouse"),
                  firstName: customer.first_name,
                  lastName: customer.last_name == "." ? "" : customer.last_name,
                  middleName:
                    customer.middle_name == "." ? "" : customer.middle_name,
                  dob: customer.dob,
                  haspreExistingDiseases: getDiseasesList(customer.extra_info)
                    .length
                    ? true
                    : false,
                  haslifestyleQuestions:
                    customer.extra_info.alcohol == "1" ||
                    customer.extra_info.tobacco == "1",
                  isHospitalized: customer.extra_info.hospitalized,
                  otherPEDs: customer.extra_info.otherDiseases ?? "",
                  extraOldDisease: customer.extra_info.otherDiseases ?? "",
                  preExistingDiseasesList: getDiseasesList(
                    customer.extra_info
                  )?.map((item) => item.label),
                  perMemberPremium: "",
                  perMemberPremiumWithGST: "",
                })
              );
            }

            if (customer.relationship === "SON") {
              dispatch(
                addMember({
                  code: uuid(),
                  image: son,
                  policyType: "1",
                  type: "son",
                  memberTypeDisplayText: getMemberTypeDisplayText("son"),
                  firstName: customer.first_name,
                  lastName: customer.last_name == "." ? "" : customer.last_name,
                  middleName:
                    customer.middle_name == "." ? "" : customer.middle_name,

                  dob: customer.dob,
                  haspreExistingDiseases: getDiseasesList(customer.extra_info)
                    .length
                    ? true
                    : false,
                  haslifestyleQuestions:
                    customer.extra_info.alcohol == "1" ||
                    customer.extra_info.tobacco == "1",
                  isHospitalized: customer.extra_info.hospitalized,
                  otherPEDs: customer.extra_info.otherDiseases ?? "",
                  extraOldDisease: customer.extra_info.otherDiseases ?? "",
                  preExistingDiseasesList: getDiseasesList(
                    customer.extra_info
                  )?.map((item) => item.label),
                  perMemberPremium: "",
                  perMemberPremiumWithGST: "",
                })
              );
            }
            if (customer.relationship === "DAUGHTER") {
              dispatch(
                addMember({
                  code: uuid(),
                  image: daughter,
                  policyType: "1",
                  type: "daughter",
                  memberTypeDisplayText: getMemberTypeDisplayText("daughter"),
                  firstName: customer.first_name,
                  lastName: customer.last_name == "." ? "" : customer.last_name,
                  middleName:
                    customer.middle_name == "." ? "" : customer.middle_name,
                  dob: customer.dob,
                  haspreExistingDiseases: getDiseasesList(customer.extra_info)
                    .length
                    ? true
                    : false,
                  haslifestyleQuestions:
                    customer.extra_info.alcohol == "1" ||
                    customer.extra_info.tobacco == "1",
                  isHospitalized: customer.extra_info.hospitalized,
                  otherPEDs: customer.extra_info.otherDiseases ?? "",
                  extraOldDisease: customer.extra_info.otherDiseases ?? "",
                  preExistingDiseasesList: getDiseasesList(
                    customer.extra_info
                  )?.map((item) => item.label),
                  perMemberPremium: "",
                  perMemberPremiumWithGST: "",
                })
              );
            }
          });
        }
      }

      if (policy.policy_name === "policy2") {
        if (isOldUser) checkforOldmembersHavingChronicDisease(policy.customers);
        dispatch(
          updatePolicyDetails({
            type: "policy2Data",
            data: {
              deductible: policy.deductibles.toString(),
              sumInsured: policy.customers[0].extra_info.sumInsured.toString(),
              premium: (policy.master_premium / 1.18).toString(),
              premiumWithGST: policy.master_premium.toString(),
              id: "2",
            },
          })
        );
        if (policy.customers) {
          policy.customers.forEach((customer) => {
            if (customer.relationship === "FATHER") {
              dispatch(
                addMember({
                  code: uuid(),
                  image: father,
                  policyType: "1",
                  type: "father",
                  memberTypeDisplayText: getMemberTypeDisplayText("father"),
                  firstName: customer.first_name,
                  lastName: customer.last_name == "." ? "" : customer.last_name,
                  middleName:
                    customer.middle_name == "." ? "" : customer.middle_name,
                  dob: customer.dob,
                  haspreExistingDiseases: getDiseasesList(customer.extra_info)
                    .length
                    ? true
                    : false,
                  haslifestyleQuestions:
                    customer.extra_info.alcohol == "1" ||
                    customer.extra_info.tobacco == "1",
                  isHospitalized: customer.extra_info.hospitalized,
                  otherPEDs: customer.extra_info.otherDiseases ?? "",
                  extraOldDisease: customer.extra_info.otherDiseases ?? "",
                  preExistingDiseasesList: getDiseasesList(
                    customer.extra_info
                  )?.map((item) => item.label),
                  perMemberPremium: "",
                  perMemberPremiumWithGST: "",
                })
              );
            }

            if (customer.relationship === "MOTHER") {
              dispatch(
                addMember({
                  code: uuid(),
                  image: mother,
                  policyType: "1",
                  type: "mother",
                  memberTypeDisplayText: getMemberTypeDisplayText("mother"),
                  firstName: customer.first_name,
                  lastName: customer.last_name == "." ? "" : customer.last_name,
                  middleName:
                    customer.middle_name == "." ? "" : customer.middle_name,
                  dob: customer.dob,
                  haspreExistingDiseases: getDiseasesList(customer.extra_info)
                    .length
                    ? true
                    : false,
                  haslifestyleQuestions:
                    customer.extra_info.alcohol == "1" ||
                    customer.extra_info.tobacco == "1",
                  isHospitalized: customer.extra_info.hospitalized,
                  otherPEDs: customer.extra_info.otherDiseases ?? "",
                  extraOldDisease: customer.extra_info.otherDiseases ?? "",
                  preExistingDiseasesList: getDiseasesList(
                    customer.extra_info
                  )?.map((item) => item.label),
                  perMemberPremium: "",
                  perMemberPremiumWithGST: "",
                })
              );
            }
          });
        }
      }

      if (policy.policy_name === "policy3") {
        if (isOldUser) checkforOldmembersHavingChronicDisease(policy.customers);
        dispatch(
          updatePolicyDetails({
            type: "policy3Data",
            data: {
              deductible: policy.deductibles.toString(),
              sumInsured: policy.customers[0].extra_info.sumInsured.toString(),
              premium: (policy.master_premium / 1.18).toString(),
              premiumWithGST: policy.master_premium.toString(),
              id: "3",
            },
          })
        );
        if (policy.customers) {
          policy.customers.forEach((customer) => {
            if (customer.relationship === "FATHER_IN_LAW") {
              dispatch(
                addMember({
                  code: uuid(),
                  image: fatherInLaw,
                  policyType: "1",
                  type: "father-in-law",
                  memberTypeDisplayText:
                    getMemberTypeDisplayText("father-in-law"),
                  firstName: customer.first_name,
                  lastName: customer.last_name == "." ? "" : customer.last_name,
                  middleName:
                    customer.middle_name == "." ? "" : customer.middle_name,
                  dob: customer.dob,
                  haspreExistingDiseases: getDiseasesList(customer.extra_info)
                    .length
                    ? true
                    : false,
                  haslifestyleQuestions:
                    customer.extra_info.alcohol == "1" ||
                    customer.extra_info.tobacco == "1",
                  isHospitalized: customer.extra_info.hospitalized,
                  otherPEDs: customer.extra_info.otherDiseases ?? "",
                  extraOldDisease: customer.extra_info.otherDiseases ?? "",
                  preExistingDiseasesList: getDiseasesList(
                    customer.extra_info
                  )?.map((item) => item.label),
                  perMemberPremium: "",
                  perMemberPremiumWithGST: "",
                })
              );
            }

            if (customer.relationship === "MOTHER_IN_LAW") {
              dispatch(
                addMember({
                  code: uuid(),
                  image: motherInLaw,
                  policyType: "1",
                  type: "mother-in-law",
                  memberTypeDisplayText:
                    getMemberTypeDisplayText("mother-in-law"),
                  firstName: customer.first_name,
                  lastName: customer.last_name == "." ? "" : customer.last_name,
                  middleName:
                    customer.middle_name == "." ? "" : customer.middle_name,
                  dob: customer.dob,
                  haspreExistingDiseases: getDiseasesList(customer.extra_info)
                    .length
                    ? true
                    : false,
                  haslifestyleQuestions:
                    customer.extra_info.alcohol == "1" ||
                    customer.extra_info.tobacco == "1",
                  isHospitalized: customer.extra_info.hospitalized,
                  otherPEDs: customer.extra_info.otherDiseases ?? "",
                  extraOldDisease: customer.extra_info.otherDiseases ?? "",
                  preExistingDiseasesList: getDiseasesList(
                    customer.extra_info
                  )?.map((item) => item.label),
                  perMemberPremium: "",
                  perMemberPremiumWithGST: "",
                })
              );
            }
          });
        }
      }
    });
  };

  // useEffect(() => {
  //   if (shouldCreateLead && proposer.email) {
  //     leadCreate()
  //   }
  // }, [shouldCreateLead, proposer.email])

  useEffect(() => {
    // console.log(token);
    dispatch(updateAuthToken(token!));
    dispatch(clearPreviousPolicyMemberHavingDisease());
    if (data) {
      // console.log(convertDOBToYYYYMMDD(data.extra_info.dob));
      // console.log(data, "data");
      getPaymentStatus({ urn_number: config.clientName + data.extra_info.user_id })
        .unwrap()
        .then((res) => {
          // console.log(res, "res");
          dispatch(changeID(data.id ? data.id.toString() : ""));
          dispatch(
            updateProposerData({
              address2: data?.extra_info.address2 ?? "",
              address: data?.extra_info.address ?? "",
              course: data?.extra_info.course ?? "",
              dob: convertDOBToYYYYMMDD(data?.extra_info.dob),
              firstName: data?.extra_info.firstname ?? "",
              middleName: data?.extra_info.middlename ?? "",
              lastName: data?.extra_info.lastname ?? "",
              passingYear: data && data.extra_info && data.extra_info.passingyear && data.extra_info.passingyear.length === 4 ? data.extra_info.passingyear : '',
              phoneNumber: data?.extra_info.phone ?? "",
              pincode: data?.extra_info.pincode ?? "",
              salutation: ['Mr', 'Mrs', 'Miss'].includes(data?.extra_info?.salutation) ? data?.extra_info?.salutation ?? '' : '',
              code: data?.extra_info.client_id,
              rollNumber: data?.extra_info.rollnumber ?? "",
              email: data?.extra_info.emailid ?? "",
              userId: data?.extra_info.user_id,
              cityName: "NA",
              stateName: "",
              stateDisplayName: "",
            })
          );
          // setShouldCreateLead(true)
          dispatch(clearDisabledProposerFields())

          if (data?.extra_info.passingyear && data?.extra_info.passingyear.trim() && data?.extra_info.passingyear.trim().length === 4) {
            dispatch(updateDisabledProposerFields(['passing_year']))
          }
          if (data?.extra_info.course && data?.extra_info.course.trim()) {
            dispatch(updateDisabledProposerFields(['course_name']))

          }
          if (res.payment_status === 1) {
            navigate("/policy-summary");
          } else if (res.payment_status === 0) {
            // Check For existing User Data
            dispatch(updateLeadUID({uid:''}))
            getLeadListing({
              page: 1,
              page_size: 1
            }).unwrap().then(response => {

             
              if (response.results.length) {
                const lead = response.results[0].lead_data.members
                dispatch(updateMembersStoreData({
                  leadUID: response.results[0].lead_uid,
                  members: lead.members,
                  nomineeDob: lead.nomineeDob,
                  nomineeName: lead.nomineeName,
                  nomineeRelationship: lead.nomineeRelationship,
                  panNumber: lead.panNumber,
                  policyDetails: lead.policyDetails,
                  proposer: lead.proposer
                }))
              }
               // Setting New User
              dispatch(updateUserStatus(true))
              if (searchParams.get('redirect_to')?.toLowerCase() === 'payment') {
                dispatch(updatePaymentModalStatus(true));
                navigate('/payment');
                return;
              }
              navigate("/");
            })


            // getListing({
            //   urn_number: config.clientName + data.extra_info.user_id,
            //   status: "1",
            //   // urn_number:'IIMK3318',status:"1"
            // })
            //   .unwrap()
            //   .then((res) => {
            //     // console.log(res, '-------0000-------------')

            //     const customerData = Object.values(res);
            //     if (customerData.length == 0) {
            //       dispatch(updateUserStatus(true));
            //       navigate("/");

            //       // return;
            //     }
            //     // else {
            //     // dispatch(updateUserStatus(false));
            //     // console.log("store your old data here!");
            //     // const polices: HealthListingPolicyDetails[] = Object.values(
            //     //   customerData[0]
            //     // );
            //     // deleteAndUpdateNewMemberData(polices, true);
            //     // }


            //     // Check For latest data of that User

            //     getListing({
            //       urn_number: config.clientName + data.extra_info.user_id,
            //     })
            //       .unwrap()
            //       .then((res) => {
            //         const customerData = Object.values(res);
            //         if (customerData.length == 0) {
            //           navigate("/");
            //           return;
            //         } else {
            //           const polices: HealthListingPolicyDetails[] =
            //             Object.values(customerData[0]);
            //           deleteAndUpdateNewMemberData(polices, false);
            //           navigate("/");

            //           return;
            //         }
            //       })
            //       .catch((e) => {
            //         console.log(e);
            //         showErrorToast({
            //           title: "Something Went Wrong!",
            //         });
            //       });
            //   })
            //   .catch((e) => {
            //     console.log(e);
            //     showErrorToast({
            //       title: "Oops, something went wrong",
            //     });
            //   });
          }
        })
        .catch((err) => {
          // console.log(err, "error");
          showErrorToast({
            title: "Something Went Wrong, Please Try Again",
          });
        });
    }
  }, [data]);

  return (
    <Box
      display={"flex"}
      justifyContent="center"
      alignItems={"center"}
      className="h-screen w-screen"
      textAlign={'center'}
    >
      <Box>
        <Text lineHeight={'32px'} fontSize={isMobile ? '2xl' : '4xl'} fontWeight={'medium'}>Redirecting to</Text>
        <Text fontSize={isMobile ? '2xl' : '4xl'} fontWeight={'medium'}>Zopper Insurance Portal...</Text>
        <Center mt='8'>
          <Box border={'1px'} borderColor={'primary.700'} h={isMobile ? '36' : '52'} w={isMobile ? '36' : '52'} rounded={'full'} overflow={'hidden'} shadow={'xl'}>
            <Lottie animationData={HeartJson} loop={true} />
          </Box>
        </Center>
        <Text mt='4'>Please wait!</Text>
        <Text> It may take a few seconds</Text>
        {/* <Center>
        <Spinner />
      </Center> */}
      </Box>
    </Box>
  );
};

export default SSOLogin;
